import { MessageBox } from 'element-ui';

const CURRENT_BUILD_ID = process.env.VUE_APP_BUILD_ID || 'development';
const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const SNOOZE_MS = 10 * 60 * 1000;

let checking = false;
let prompting = false;
let snoozedUntil = 0;

function refreshToBuild(buildId) {
  const url = new URL(window.location.href);
  url.searchParams.set('__release', buildId);
  window.location.replace(url.toString());
}

export async function checkForNewVersion() {
  if (checking || prompting || Date.now() < snoozedUntil) return;
  checking = true;
  try {
    const response = await fetch(`/json/version.json?t=${Date.now()}`, {
      cache: 'no-store',
      credentials: 'same-origin',
    });
    if (!response.ok) return;
    const manifest = await response.json();
    const latestBuildId = String(manifest.buildId || '');
    if (!latestBuildId || latestBuildId === CURRENT_BUILD_ID) return;

    prompting = true;
    try {
      await MessageBox.confirm(
        '系统已有新版本。为避免继续使用旧页面，请刷新后继续。',
        '系统更新提示',
        {
          confirmButtonText: '立即刷新',
          cancelButtonText: '稍后提醒',
          type: 'info',
          closeOnClickModal: false,
        }
      );
      refreshToBuild(latestBuildId);
    } catch (_) {
      snoozedUntil = Date.now() + SNOOZE_MS;
    } finally {
      prompting = false;
    }
  } catch (_) {
    // A failed update probe must never interrupt the current customer session.
  } finally {
    checking = false;
  }
}

export function startVersionMonitor() {
  if (process.env.NODE_ENV !== 'production' || CURRENT_BUILD_ID === 'development') return;

  window.setTimeout(checkForNewVersion, 30 * 1000);
  window.setInterval(checkForNewVersion, CHECK_INTERVAL_MS);
  window.addEventListener('focus', checkForNewVersion);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkForNewVersion();
  });
}
